<template>
	<ModalRouting
		:loading="loading"
		:title="'Rota do motorista ' + current.nickname + ' - Carga: ' + (current.current_cargo ? current.current_cargo : 'Não definida')"
		@close="close"
	>
		<div v-if="loading">
			<div class="loading">
				<i class="fa fa-circle-notch fa-spin"></i>
			</div>
		</div>
		<div v-else class="row">
			<div class="col-xs-12">
				<RouteGoogleMaps
					:driver="current"
					:deliveries="current_data.deliveries"
					:positions="current_data.positions"
					:settings="current_data.settings"
					ref="route"
				/>
			</div>
		</div>
	</ModalRouting>
</template>

<script>
import Api from "@/lib/Api";

import ModalRouting from "@/components/ModalRouting";
import RouteGoogleMaps from '../../components/RouteGoogleMaps.vue';

export default {
	name: "TrackingRoute",

	props: {
		current: {
			type: Object,
			require: true,
		},
	},

	components: {
		ModalRouting,
		RouteGoogleMaps,
	},

	data: function() {
		return {
			loading: true,
			current_data: {},
		}
	},

	created: async function() {
		// Sinaliza o carregamento
		this.loading = true;
		// Requsita todas as informações
		await this.load();
		// Sinaliza o fim do carregamento
		this.loading = false;
	},
	
	methods: {
		/**
		 * Requisita a API os pontos
		 **/
		load: async function() {
			// Inicia o objeto de resultado
			let result = null;
			
			// Obtém as informações da rota
			try {
				result = await Api.post('tracking/get-route', {
					id: this.current.id,
					document: this.current.document,
					license_plate: this.current.current_license_plate,
					cargo: this.current.current_cargo,
				});
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter a rota.");
				this.close();
				return;
			}
			
			// Verifica se foi retornado algo
			if(result != null) {
				if(result.error) {
					this.$notification.error(result.data);
					this.close();
					return;
				}

				if(result.data.length == 0) {
					this.$notification.error("Nenhuma rota disponível neste momento.");
					this.close();
					return;
				} else {
					// Armazena as informações retornadas
					this.current_data = result.data;
				}
			} else {
				this.$notification.error("Nenhuma rota encontrada.");
				this.close();
				return;
			}
		},

		/**
		 * Fecha o modal
		 */
		close: function() {
			this.$emit("close");
		},
	}
}
</script>

<style scoped>
.loading {
    height: calc(100vh - 112px);
    width: calc(100vw - 61px);
	position: absolute;
    background: #fff;
    font-size: 80px;
	color: #ddd;
    text-align: center;
    line-height: calc(100vh - 112px);
    font-family: Verdana;
    z-index: 10;
}
</style>